var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleGuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7C12.3411 7 9.375 9.96611 9.375 13.625C9.375 16.1439 10.7808 18.3345 12.8506 19.455C11.9164 19.7307 11.0181 20.1292 10.1801 20.6436C8.42915 21.7183 7.01002 23.2569 6.07998 25.0888C5.82997 25.5812 6.0265 26.1831 6.51896 26.4332C7.01141 26.6832 7.6133 26.4866 7.86332 25.9942C8.62615 24.4916 9.79016 23.2296 11.2263 22.3481C12.6625 21.4666 14.3147 21 15.9998 21C17.6849 21 19.3371 21.4666 20.7732 22.3481C22.2094 23.2296 23.3734 24.4916 24.1362 25.9942C24.3862 26.4866 24.9881 26.6832 25.4806 26.4332C25.973 26.1831 26.1696 25.5812 25.9196 25.0888C24.9895 23.2569 23.5704 21.7183 21.8195 20.6436C20.9816 20.1293 20.0833 19.7308 19.1492 19.4551C21.2191 18.3346 22.625 16.144 22.625 13.625C22.625 9.96611 19.6589 7 16 7ZM11.375 13.625C11.375 11.0707 13.4457 9 16 9C18.5543 9 20.625 11.0707 20.625 13.625C20.625 16.1793 18.5543 18.25 16 18.25C13.4457 18.25 11.375 16.1793 11.375 13.625Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 4H7C5.34315 4 4 5.34315 4 7V25C4 26.6569 5.34315 28 7 28H25C26.6569 28 28 26.6569 28 25V7C28 5.34315 26.6569 4 25 4ZM7 2C4.23858 2 2 4.23858 2 7V25C2 27.7614 4.23858 30 7 30H25C27.7614 30 30 27.7614 30 25V7C30 4.23858 27.7614 2 25 2H7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleGuest);
export default __webpack_public_path__ + "static/media/role-guest.f0b1df417803004fe19716607e1f3d6d.svg";
export { ForwardRef as ReactComponent };